import 'react-image-crop/dist/ReactCrop.css';
import './ImgCropper.scss';

import React, {
  forwardRef,
  useCallback,
  useState,
} from 'react';
import ReactCrop, { centerCrop, Crop, makeAspectCrop } from 'react-image-crop';

const DEFAULT_ASPECT_RATIO = 1;

interface IImgCropperProps {
  img: string;
  crop?: Crop;
  keepSelection?: boolean;
  circularCrop?: boolean;
  setCrop: React.Dispatch<React.SetStateAction<Crop | undefined>>;
}

const ImgCropper = ({
  img,
  crop,
  keepSelection = false,
  circularCrop = false,
  setCrop,
}: IImgCropperProps, ref: React.Ref<HTMLImageElement>) => {
  const [zoom, setZoom] = useState(1);

  const onLoad = useCallback(() => {
    // eslint-disable-next-line react/destructuring-assignment
    if (!ref || !('current' in ref) || !ref.current) return;
    // eslint-disable-next-line react/destructuring-assignment
    const { naturalWidth: width, naturalHeight: height } = ref.current;
    const centredCrop = centerAspectCrop(width, height, DEFAULT_ASPECT_RATIO);
    setCrop(centredCrop);
  }, [ref, setCrop]);

  return (
    <div className="img-cropper">
      <ReactCrop
        aspect={DEFAULT_ASPECT_RATIO}
        crop={crop}
        keepSelection={keepSelection}
        circularCrop={circularCrop}
        onChange={setCrop}
      >
        <img
          style={{ transform: `scale(${zoom})`, transformOrigin: 'center' }}
          src={img}
          ref={ref}
          onLoad={onLoad}
          alt="preview"
        />
      </ReactCrop>
      <input
        className="img-cropper__range"
        type="range"
        min="1"
        max="3"
        step="0.1"
        value={zoom}
        onChange={(e) => setZoom(parseFloat(e.target.value))}
        aria-label="Zoom"
      />
    </div>
  );
};

export default forwardRef<HTMLImageElement, IImgCropperProps>(ImgCropper);

const centerAspectCrop = (
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) => centerCrop(
  makeAspectCrop(
    {
      unit: '%',
      width: 75,
    },
    aspect,
    mediaWidth,
    mediaHeight,
  ),
  mediaWidth,
  mediaHeight,
);
